export const MOCK_METER_LIST = {
  data: [
    {
      ma_lo_id: '1231231231',
      meter_type: 'bellow-gas-meter',
      meter_number: '123123123',
      sector: 'gas',
      status: 'active',
      _tags: [],
      _schema: 'meter',
      _id: '571f64fc-ed24-4da5-8026-2bbaabe84065',
      _org: '16246022',
      _created_at: '2025-04-22T11:09:20.751Z',
      _title: '123123123',
      obis_number: '123123123',
      direction: 'feed-in',
      unit: 'kWh',
      contract: [
        {
          _id: '37cf1e00-d21f-4427-a1e0-d831d094b1cd',
          line_items: [
            {
              price_id: 'c2af43bd-1943-43d7-bfb8-972e815637eb',
              product_id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
              quantity: 1,
              description: 'Ladestrom+',
              unit_amount: 0,
              unit_amount_decimal: '0.00',
              pricing_model: null,
              item_components: [
                {
                  price_id: 'dc873208-29f2-4efc-be89-028fc8b547d7',
                  product_id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
                  quantity: 1,
                  description: 'Grundpreis',
                  unit_amount: 1085,
                  unit_amount_decimal: '10.85',
                  pricing_model: 'per_unit',
                  _price: {
                    _id: 'dc873208-29f2-4efc-be89-028fc8b547d7',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    description: 'Grundpreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    tiers: [],
                    type: 'recurring',
                    unit_amount: 1085,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '10.85',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Grundpreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Grundpreis'
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature:
                          '100% Ökostrom für Ihr Elektroauto - Gesonderter Zähler mit Rundsteuerempfänger (Steuergerät) notwendig',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Dummy - Ladestrom Commodity',
                    name: 'Ladestrom+',
                    price_options: [
                      {
                        _id: 'c2af43bd-1943-43d7-bfb8-972e815637eb',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Ladestrom'],
                        active: true,
                        description: 'Ladestrom+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Dummy - Ladestrom Commodity',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.640Z',
                        _updated_at: '2025-04-09T07:44:56.496Z',
                        _title: 'Ladestrom+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: 'c2af43bd-1943-43d7-bfb8-972e815637eb'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [
                      {
                        _id: '0b53d7ea-cf5f-4ff7-a02e-b0ecc81ceb02',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                        _tags: ['Commodity', 'Produkt-Illustration'],
                        _title: 'Commodity charging.png',
                        access_control: 'public-read',
                        filename: 'Commodity charging.png',
                        mime_type: 'image/png',
                        type: 'image',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 89348,
                        readable_size: '87.25 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%2520charging.png',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%20charging.png'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                            _tags: ['Commodity', 'Produkt-Illustration'],
                            _title: 'Commodity charging.png',
                            access_control: 'public-read',
                            filename: 'Commodity charging.png',
                            mime_type: 'image/png',
                            type: 'image',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 89348,
                            readable_size: '87.25 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%2520charging.png',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%20charging.png'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:24.409Z',
                        _updated_at: '2025-04-04T07:57:24.797Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-LUsyKjvaSXyuRNR4Pyjcy/Commodity%20charging.png?hash=f327c9ef',
                        $relation: {
                          entity_id: '0b53d7ea-cf5f-4ff7-a02e-b0ecc81ceb02'
                        }
                      }
                    ],
                    type: 'product',
                    _id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
                    _title: 'Ladestrom+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 173
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_net: 912,
                  unit_amount_gross: 1085,
                  amount_subtotal: 912,
                  amount_total: 1085,
                  amount_tax: 173,
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '9.117647058824',
                  unit_amount_gross_decimal: '10.85',
                  amount_subtotal_decimal: '9.117647058824',
                  amount_total_decimal: '10.85'
                },
                {
                  price_id: '93528f8f-0f46-4a83-8862-3d2844632e82',
                  product_id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
                  quantity: 1,
                  description: 'Arbeitspreis',
                  unit_amount: 28,
                  unit_amount_decimal: '0.282',
                  pricing_model: 'per_unit',
                  _price: {
                    _id: '93528f8f-0f46-4a83-8862-3d2844632e82',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    description: 'Arbeitspreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 28,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.2820',
                    variable_price: true,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Arbeitspreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Arbeitspreis'
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature:
                          '100% Ökostrom für Ihr Elektroauto - Gesonderter Zähler mit Rundsteuerempfänger (Steuergerät) notwendig',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Dummy - Ladestrom Commodity',
                    name: 'Ladestrom+',
                    price_options: [
                      {
                        _id: 'c2af43bd-1943-43d7-bfb8-972e815637eb',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Ladestrom'],
                        active: true,
                        description: 'Ladestrom+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Dummy - Ladestrom Commodity',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.640Z',
                        _updated_at: '2025-04-09T07:44:56.496Z',
                        _title: 'Ladestrom+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: 'c2af43bd-1943-43d7-bfb8-972e815637eb'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [
                      {
                        _id: '0b53d7ea-cf5f-4ff7-a02e-b0ecc81ceb02',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                        _tags: ['Commodity', 'Produkt-Illustration'],
                        _title: 'Commodity charging.png',
                        access_control: 'public-read',
                        filename: 'Commodity charging.png',
                        mime_type: 'image/png',
                        type: 'image',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 89348,
                        readable_size: '87.25 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%2520charging.png',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%20charging.png'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                            _tags: ['Commodity', 'Produkt-Illustration'],
                            _title: 'Commodity charging.png',
                            access_control: 'public-read',
                            filename: 'Commodity charging.png',
                            mime_type: 'image/png',
                            type: 'image',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 89348,
                            readable_size: '87.25 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%2520charging.png',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%20charging.png'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:24.409Z',
                        _updated_at: '2025-04-04T07:57:24.797Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-LUsyKjvaSXyuRNR4Pyjcy/Commodity%20charging.png?hash=f327c9ef',
                        $relation: {
                          entity_id: '0b53d7ea-cf5f-4ff7-a02e-b0ecc81ceb02'
                        }
                      }
                    ],
                    type: 'product',
                    _id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
                    _title: 'Ladestrom+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 0
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_net: 24,
                  unit_amount_gross: 28,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_tax: 0,
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '0.236974789916',
                  unit_amount_gross_decimal: '0.282',
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0'
                }
              ],
              _price: {
                _id: 'c2af43bd-1943-43d7-bfb8-972e815637eb',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                _tags: ['Commodity', 'Ladestrom'],
                active: true,
                description: 'Ladestrom+',
                is_composite_price: true,
                is_tax_inclusive: null,
                price_components: [
                  {
                    _id: 'dc873208-29f2-4efc-be89-028fc8b547d7',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    description: 'Grundpreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    tiers: [],
                    type: 'recurring',
                    unit_amount: 1085,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '10.85',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Grundpreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Grundpreis'
                  },
                  {
                    _id: '93528f8f-0f46-4a83-8862-3d2844632e82',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    description: 'Arbeitspreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 28,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.2820',
                    variable_price: true,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Arbeitspreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Arbeitspreis'
                  }
                ],
                price_display_in_journeys: 'show_price',
                pricing_model: null,
                tiers: [],
                type: null,
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: null,
                billing_duration_amount: null,
                billing_duration_unit: null,
                billing_period: null,
                internal_description: 'Dummy - Ladestrom Commodity',
                notice_time_amount: null,
                notice_time_unit: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                unit: null,
                _title: 'Ladestrom+'
              },
              _product: {
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                _tags: ['Commodity', 'Ladestrom'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature:
                      '100% Ökostrom für Ihr Elektroauto - Gesonderter Zähler mit Rundsteuerempfänger (Steuergerät) notwendig',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Dummy - Ladestrom Commodity',
                name: 'Ladestrom+',
                price_options: [
                  {
                    _id: 'c2af43bd-1943-43d7-bfb8-972e815637eb',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Ladestrom'],
                    active: true,
                    description: 'Ladestrom+',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Dummy - Ladestrom Commodity',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.640Z',
                    _updated_at: '2025-04-09T07:44:56.496Z',
                    _title: 'Ladestrom+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: 'c2af43bd-1943-43d7-bfb8-972e815637eb'
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.522Z',
                    _updated_at: '2025-04-04T07:57:21.022Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                    $relation: {
                      entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                    }
                  },
                  {
                    _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.247Z',
                    _updated_at: '2025-04-04T07:57:21.704Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                    $relation: {
                      entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                    }
                  },
                  {
                    _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.101Z',
                    _updated_at: '2025-04-04T07:57:21.569Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                    $relation: {
                      entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                    }
                  },
                  {
                    _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.386Z',
                    _updated_at: '2025-04-04T07:57:20.823Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                    $relation: {
                      entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                    }
                  }
                ],
                product_images: [
                  {
                    _id: '0b53d7ea-cf5f-4ff7-a02e-b0ecc81ceb02',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                    _tags: ['Commodity', 'Produkt-Illustration'],
                    _title: 'Commodity charging.png',
                    access_control: 'public-read',
                    filename: 'Commodity charging.png',
                    mime_type: 'image/png',
                    type: 'image',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 89348,
                    readable_size: '87.25 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%2520charging.png',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%20charging.png'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['8e04c5fc-191d-4576-90f9-8bbb20ff02a7'],
                        _tags: ['Commodity', 'Produkt-Illustration'],
                        _title: 'Commodity charging.png',
                        access_control: 'public-read',
                        filename: 'Commodity charging.png',
                        mime_type: 'image/png',
                        type: 'image',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 89348,
                        readable_size: '87.25 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%2520charging.png',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/75d6fe43-8018-4b38-ac59-79d5a258425f/Commodity%20charging.png'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:24.409Z',
                    _updated_at: '2025-04-04T07:57:24.797Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-LUsyKjvaSXyuRNR4Pyjcy/Commodity%20charging.png?hash=f327c9ef',
                    $relation: {
                      entity_id: '0b53d7ea-cf5f-4ff7-a02e-b0ecc81ceb02'
                    }
                  }
                ],
                type: 'product',
                _id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
                _title: 'Ladestrom+',
                _messages: {}
              },
              price_mappings: [
                {
                  price_id: '93528f8f-0f46-4a83-8862-3d2844632e82',
                  value: 0
                }
              ],
              currency: 'EUR',
              amount_subtotal: 912,
              amount_total: 1085,
              total_details: {
                amount_tax: 173,
                breakdown: {
                  taxes: [
                    {
                      tax: {
                        _id: '170d696a-611a-4627-a904-137741027989',
                        type: 'VAT',
                        rate: '19'
                      },
                      amount: 173
                    }
                  ],
                  recurrences: [
                    {
                      type: 'recurring',
                      billing_period: 'monthly',
                      unit_amount_gross: 1113,
                      unit_amount_net: 935,
                      amount_subtotal: 912,
                      amount_total: 1085,
                      amount_subtotal_decimal: '9.117647058824',
                      amount_total_decimal: '10.85',
                      amount_tax: 173
                    }
                  ],
                  recurrencesByTax: [
                    {
                      type: 'recurring',
                      billing_period: 'monthly',
                      amount_total: 1085,
                      amount_subtotal: 912,
                      amount_tax: 173,
                      tax: {
                        tax: {
                          _id: '170d696a-611a-4627-a904-137741027989',
                          type: 'VAT',
                          rate: '19'
                        },
                        amount: 173
                      }
                    }
                  ],
                  cashbacks: []
                }
              },
              amount_tax: 173,
              amount_subtotal_decimal: '9.117647058824',
              amount_total_decimal: '10.85'
            }
          ],
          amount_subtotal: 912,
          amount_total: 1085,
          total_details: {
            amount_tax: 173,
            breakdown: {
              taxes: [
                {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 173
                }
              ],
              recurrences: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_gross: 1113,
                  unit_amount_net: 935,
                  amount_subtotal: 912,
                  amount_total: 1085,
                  amount_subtotal_decimal: '9.117647058824',
                  amount_total_decimal: '10.85',
                  amount_tax: 173
                }
              ],
              recurrencesByTax: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  amount_total: 1085,
                  amount_subtotal: 912,
                  amount_tax: 173,
                  tax: {
                    tax: {
                      _id: '170d696a-611a-4627-a904-137741027989',
                      type: 'VAT',
                      rate: '19'
                    },
                    amount: 173
                  }
                }
              ],
              cashbacks: []
            }
          },
          currency: 'EUR',
          redeemed_promos: [],
          contract_name: 'Maxine Spark',
          contract_number: '658901022',
          start_date: '2025-01-01',
          end_date: '2025-12-31',
          type: 'recurring',
          installment_amount: 9900,
          installment_amount_currency: 'EUR',
          installment_amount_decimal: '99',
          products: {
            $relation: [
              {
                entity_id: 'c2adea5b-553e-46fb-8109-85e73c4e7ae2',
                _schema: 'product',
                _tags: []
              }
            ]
          },
          balance: 0,
          balance_currency: 'EUR',
          balance_decimal: '0.00',
          prices: {
            $relation: [
              {
                entity_id: 'c2af43bd-1943-43d7-bfb8-972e815637eb',
                _schema: 'price',
                _tags: []
              }
            ]
          },
          _schema: 'contract',
          status: 'deactivated',
          amount_tax: 173,
          billing_period: 'monthly',
          billing_duration_amount: null,
          _org: '16246022',
          _created_at: '2025-04-22T10:08:39.668Z',
          _updated_at: '2025-05-20T06:15:02.202Z',
          billing_duration_unit: 'months',
          notice_time_unit: 'months',
          termination_time_unit: 'months',
          renewal_duration_unit: 'months',
          _title: 'Maxine Spark',
          move_in_date: '2025-01-01',
          order: {
            $relation: [
              {
                entity_id: 'eaa61bfb-fc94-4f11-8cac-a3183a2f31fd',
                _schema: 'order',
                _tags: []
              }
            ]
          },
          meters: {
            $relation: [
              {
                entity_id: '6f4f9267-3372-4602-a542-babbe0515c03',
                _tags: []
              },
              {
                entity_id: '571f64fc-ed24-4da5-8026-2bbaabe84065',
                _tags: []
              }
            ]
          },
          customer: {
            $relation: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                _schema: 'contact',
                _tags: []
              }
            ]
          },
          delivery_address: [
            {
              _id: '5NpAsJLJNTlhxXsHDWBve',
              _tags: [],
              street: 'Adolf-Fischer-Str.',
              zip: '',
              city: 'Köln',
              country: 'DE',
              postal_code: '50670',
              street_number: '2',
              additional_info: '1. OG rechts'
            }
          ],
          billing_address: {
            $relation_ref: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                path: 'address',
                _id: 'L6sB14Iori1DB0PodxizK'
              }
            ]
          },
          payment: {
            $relation_ref: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                path: 'payment',
                _id: 'UvxxbZ13mCnwchDZxheL8'
              }
            ]
          },
          billing_due_day: '1',
          notice_time_amount: '2',
          _files: {
            $relation: [
              {
                entity_id: '84c561eb-2798-43b5-9378-72ca959b4e2a',
                _tags: [''],
                added_by: {
                  org_id: '16246022',
                  user_id: '161180'
                }
              }
            ]
          },
          branch: 'power',
          _tags: ['copy'],
          $relation: {
            entity_id: '37cf1e00-d21f-4427-a1e0-d831d094b1cd'
          }
        }
      ],
      _updated_at: '2025-04-22T11:16:33.857Z',
      meter: [
        {
          _id: '571f64fc-ed24-4da5-8026-2bbaabe84065',
          ma_lo_id: '1231231231',
          meter_type: 'bellow-gas-meter',
          meter_number: '123123123',
          sector: 'gas',
          status: 'active',
          _tags: [],
          _schema: 'meter',
          _org: '16246022',
          _created_at: '2025-04-22T11:09:20.751Z',
          _title: '123123123',
          obis_number: '123123123',
          direction: 'feed-in',
          unit: 'kWh',
          contract: {
            $relation: [
              {
                entity_id: '37cf1e00-d21f-4427-a1e0-d831d094b1cd'
              }
            ]
          },
          _updated_at: '2025-04-22T11:16:33.857Z',
          meter: {
            $relation: [
              {
                entity_id: '571f64fc-ed24-4da5-8026-2bbaabe84065',
                _schema: 'meter',
                _tags: []
              }
            ]
          },
          counters: {
            $relation: [
              {
                entity_id: '947e9850-7d46-4fa8-a42e-bc7d56aef395',
                _tags: []
              }
            ]
          },
          _files: {
            $relation: [
              {
                entity_id: '590f2b13-6e09-443b-8782-819046637a8c'
              },
              {
                entity_id: '90454815-b0da-49e2-a892-aae7e9fbc013'
              },
              {
                entity_id: 'ccce5d6b-ea4e-4025-b1dc-e316d74ab885'
              },
              {
                entity_id: '665bd015-cb1c-4470-a6d0-4794e21ed0b7'
              }
            ]
          },
          $relation: {
            entity_id: '571f64fc-ed24-4da5-8026-2bbaabe84065',
            _schema: 'meter',
            _tags: []
          }
        }
      ],
      counters: [
        {
          _id: '947e9850-7d46-4fa8-a42e-bc7d56aef395',
          obis_number: '123123123',
          direction: 'feed-out',
          unit: 'kWh',
          _tags: [],
          _schema: 'meter_counter',
          _org: '16246022',
          _created_at: '2025-04-22T11:11:50.257Z',
          _updated_at: '2025-04-22T11:11:50.257Z',
          _title: '123123123',
          $relation: {
            entity_id: '947e9850-7d46-4fa8-a42e-bc7d56aef395',
            _tags: []
          }
        }
      ],
      _files: [
        {
          _id: '590f2b13-6e09-443b-8782-819046637a8c',
          filename: 'Ablesung 2025-04-22T16:42:23+05:30.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/d307ee7e-18f1-4bc1-8951-1c7d3abb220e/Ablesung%25202025-04-22T16%253A42%253A23%252B05%253A30.jpg',
          size_bytes: 99532,
          readable_size: '97.2 KB',
          mime_type: 'image/png',
          width: 1430,
          height: 1486,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/d307ee7e-18f1-4bc1-8951-1c7d3abb220e/Ablesung%202025-04-22T16%3A42%3A23%2B05%3A30.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-04-22T16:42:23+05:30.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/d307ee7e-18f1-4bc1-8951-1c7d3abb220e/Ablesung%25202025-04-22T16%253A42%253A23%252B05%253A30.jpg',
              size_bytes: 99532,
              readable_size: '97.2 KB',
              mime_type: 'image/png',
              width: 1430,
              height: 1486,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/d307ee7e-18f1-4bc1-8951-1c7d3abb220e/Ablesung%202025-04-22T16%3A42%3A23%2B05%3A30.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-04-22T11:12:25.657Z',
          _updated_at: '2025-04-22T11:12:25.657Z',
          _title: 'Ablesung 2025-04-22T16:42:23+05:30.jpg',
          $relation: {
            entity_id: '590f2b13-6e09-443b-8782-819046637a8c'
          }
        },
        {
          _id: '90454815-b0da-49e2-a892-aae7e9fbc013',
          filename: 'Ablesung 2025-04-22T16:44:14+05:30.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/76f18b60-a5e9-41d0-894e-dda0fb09ef95/Ablesung%25202025-04-22T16%253A44%253A14%252B05%253A30.jpg',
          size_bytes: 99532,
          readable_size: '97.2 KB',
          mime_type: 'image/png',
          width: 1430,
          height: 1486,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/76f18b60-a5e9-41d0-894e-dda0fb09ef95/Ablesung%202025-04-22T16%3A44%3A14%2B05%3A30.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-04-22T16:44:14+05:30.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/76f18b60-a5e9-41d0-894e-dda0fb09ef95/Ablesung%25202025-04-22T16%253A44%253A14%252B05%253A30.jpg',
              size_bytes: 99532,
              readable_size: '97.2 KB',
              mime_type: 'image/png',
              width: 1430,
              height: 1486,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/76f18b60-a5e9-41d0-894e-dda0fb09ef95/Ablesung%202025-04-22T16%3A44%3A14%2B05%3A30.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-04-22T11:14:16.469Z',
          _updated_at: '2025-04-22T11:14:16.469Z',
          _title: 'Ablesung 2025-04-22T16:44:14+05:30.jpg',
          $relation: {
            entity_id: '90454815-b0da-49e2-a892-aae7e9fbc013'
          }
        },
        {
          _id: 'ccce5d6b-ea4e-4025-b1dc-e316d74ab885',
          filename: 'Ablesung 2025-04-22T16:45:53+05:30.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/822b9ebb-1217-4246-86ea-1f612a9ae4b6/Ablesung%25202025-04-22T16%253A45%253A53%252B05%253A30.jpg',
          size_bytes: 99532,
          readable_size: '97.2 KB',
          mime_type: 'image/png',
          width: 1430,
          height: 1486,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/822b9ebb-1217-4246-86ea-1f612a9ae4b6/Ablesung%202025-04-22T16%3A45%3A53%2B05%3A30.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-04-22T16:45:53+05:30.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/822b9ebb-1217-4246-86ea-1f612a9ae4b6/Ablesung%25202025-04-22T16%253A45%253A53%252B05%253A30.jpg',
              size_bytes: 99532,
              readable_size: '97.2 KB',
              mime_type: 'image/png',
              width: 1430,
              height: 1486,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/822b9ebb-1217-4246-86ea-1f612a9ae4b6/Ablesung%202025-04-22T16%3A45%3A53%2B05%3A30.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-04-22T11:15:55.369Z',
          _updated_at: '2025-04-22T11:15:55.369Z',
          _title: 'Ablesung 2025-04-22T16:45:53+05:30.jpg',
          $relation: {
            entity_id: 'ccce5d6b-ea4e-4025-b1dc-e316d74ab885'
          }
        },
        {
          _id: '665bd015-cb1c-4470-a6d0-4794e21ed0b7',
          filename: 'Ablesung 2025-04-22T16:46:32+05:30.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ca37dc25-3c37-482d-983d-4f3b5667d463/Ablesung%25202025-04-22T16%253A46%253A32%252B05%253A30.jpg',
          size_bytes: 99532,
          readable_size: '97.2 KB',
          mime_type: 'image/png',
          width: 1430,
          height: 1486,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/ca37dc25-3c37-482d-983d-4f3b5667d463/Ablesung%202025-04-22T16%3A46%3A32%2B05%3A30.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-04-22T16:46:32+05:30.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ca37dc25-3c37-482d-983d-4f3b5667d463/Ablesung%25202025-04-22T16%253A46%253A32%252B05%253A30.jpg',
              size_bytes: 99532,
              readable_size: '97.2 KB',
              mime_type: 'image/png',
              width: 1430,
              height: 1486,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/ca37dc25-3c37-482d-983d-4f3b5667d463/Ablesung%202025-04-22T16%3A46%3A32%2B05%3A30.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-04-22T11:16:33.551Z',
          _updated_at: '2025-04-22T11:16:33.551Z',
          _title: 'Ablesung 2025-04-22T16:46:32+05:30.jpg',
          $relation: {
            entity_id: '665bd015-cb1c-4470-a6d0-4794e21ed0b7'
          }
        }
      ],
      _relations: [
        {
          entity_id: '37cf1e00-d21f-4427-a1e0-d831d094b1cd'
        },
        {
          entity_id: '571f64fc-ed24-4da5-8026-2bbaabe84065'
        },
        {
          entity_id: '590f2b13-6e09-443b-8782-819046637a8c'
        },
        {
          entity_id: '665bd015-cb1c-4470-a6d0-4794e21ed0b7'
        },
        {
          entity_id: '90454815-b0da-49e2-a892-aae7e9fbc013'
        },
        {
          entity_id: '947e9850-7d46-4fa8-a42e-bc7d56aef395'
        },
        {
          entity_id: 'ccce5d6b-ea4e-4025-b1dc-e316d74ab885'
        }
      ],
      _messages: {
        total_messages: 0,
        unread_count: 0
      },
      last_reading: '2025-04-22T11:16:12Z',
      current_consumption: 10000,
      journey_actions: []
    },
    {
      meter_type: 'smart-meter',
      meter_number: '1ESY2158347841311',
      sector: 'power',
      status: 'active',
      _tags: [],
      _schema: 'meter',
      _id: '3c95352d-32e2-486d-9991-d565f3b84e11',
      _org: '16246022',
      _created_at: '2025-05-07T11:40:35.712Z',
      _title: '1ESY2158347841311',
      contract: [
        {
          _id: '78d3639c-ef63-4517-9942-3407dda87de7',
          contract_name: 'Max Spark Dynamic Green+',
          contract_number: '589010218',
          account_number: '',
          move_in_date: '2025-05-01',
          type: 'recurring',
          installment_amount: 0,
          installment_amount_currency: 'EUR',
          installment_amount_decimal: '0.00',
          balance: 0,
          balance_currency: 'EUR',
          balance_decimal: '0.00',
          _schema: 'contract',
          _org: '16246022',
          _created_at: '2025-05-07T07:58:32.296Z',
          _updated_at: '2025-05-23T06:27:27.846Z',
          status: 'active',
          billing_period: 'monthly',
          billing_duration_unit: 'months',
          notice_time_unit: 'months',
          termination_time_unit: 'months',
          renewal_duration_unit: 'months',
          _title: 'Max Spark Dynamic Green+',
          meters: {
            $relation: [
              {
                entity_id: '3c95352d-32e2-486d-9991-d565f3b84e11',
                _tags: []
              }
            ]
          },
          customer: {
            $relation: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                _schema: 'contact',
                _tags: []
              }
            ]
          },
          line_items: [
            {
              price_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
              product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              quantity: 1,
              description: 'Dynamic Green+',
              unit_amount: 0,
              unit_amount_decimal: '0.00',
              pricing_model: 'per_unit',
              item_components: [
                {
                  price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                  product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                  quantity: 1,
                  description: 'Grundpreis',
                  unit_amount: 0,
                  unit_amount_decimal: '1.3e-9',
                  pricing_model: 'tiered_volume',
                  _price: {
                    _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                    _manifest: [
                      '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                      '50fb9921-3b0d-430a-9211-5b741e601008',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Grundpreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'tiered_volume',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    tiers: [],
                    type: 'recurring',
                    unit_amount: 1300,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '13',
                    variable_price: true,
                    billing_duration_amount: '',
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Grundpreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Grundpreis',
                    averageMarketPrice: {
                      market: 'day_ahead',
                      bidding_zone: 'DE-LU',
                      price: {
                        timestamp:
                          '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                        unit_amount: 7.79,
                        unit_amount_decimal: '0.0779',
                        unit_amount_currency: 'EUR'
                      },
                      _meta: {
                        timestamp: 1747981644144,
                        signature:
                          'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                      },
                      inputs: {
                        market: 'day_ahead',
                        bidding_zone: 'DE-LU',
                        from: '2025-04-01',
                        to: '2025-04-30'
                      }
                    }
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom', 'dont-touch'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature: '100% Ökostrom',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Strom Green+',
                    name: 'Strom Green+',
                    price_options: [
                      {
                        _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        description: 'Classic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Classic Green+',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.709Z',
                        _updated_at: '2025-05-23T06:23:55.130Z',
                        _title: 'Classic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                        }
                      },
                      {
                        _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        billing_duration_unit: 'months',
                        description: 'Dynamic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: true,
                        notice_time_unit: 'months',
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: 'per_unit',
                        renewal_duration_unit: 'months',
                        termination_time_unit: 'months',
                        tiers: [],
                        type: 'one_time',
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: false,
                        billing_period: 'weekly',
                        internal_description: 'Dynamic Green+',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.918Z',
                        _updated_at: '2025-05-23T06:24:15.056Z',
                        _title: 'Dynamic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [],
                    type: 'product',
                    _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                    _title: 'Strom Green+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 0
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  tiers_details: [
                    {
                      quantity: 0,
                      unit_amount: 0,
                      unit_amount_decimal: '0',
                      unit_amount_net: 0,
                      unit_amount_gross: 0,
                      amount_subtotal: 0,
                      amount_total: 0,
                      amount_tax: 0
                    }
                  ],
                  unit_amount_gross: 0,
                  unit_amount_net: 0,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_tax: 0,
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '0',
                  unit_amount_gross_decimal: '0',
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0'
                },
                {
                  price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                  product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                  quantity: 1,
                  description: 'Energie Spotmarktpreis',
                  unit_amount: 24,
                  unit_amount_decimal: '0.243801',
                  pricing_model: 'dynamic_tariff',
                  _price: {
                    _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Energie Spotmarktpreis',
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'dynamic_tariff',
                    renewal_duration_unit: 'months',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: true,
                    billing_period: 'monthly',
                    dynamic_tariff: {
                      interval: 'hourly',
                      markup: 0,
                      markup_amount: 15,
                      markup_amount_decimal: '0.1511',
                      markup_decimal: '0.00',
                      mode: 'day_ahead_market'
                    },
                    internal_description: 'Energie Spotmarktpreis',
                    _title: 'Energie Spotmarktpreis',
                    averageMarketPrice: {
                      market: 'day_ahead',
                      bidding_zone: 'DE-LU',
                      price: {
                        timestamp:
                          '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                        unit_amount: 7.79,
                        unit_amount_decimal: '0.0779',
                        unit_amount_currency: 'EUR'
                      },
                      _meta: {
                        timestamp: 1747981644144,
                        signature:
                          'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                      },
                      inputs: {
                        market: 'day_ahead',
                        bidding_zone: 'DE-LU',
                        from: '2025-04-01',
                        to: '2025-04-30'
                      }
                    }
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom', 'dont-touch'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature: '100% Ökostrom',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Strom Green+',
                    name: 'Strom Green+',
                    price_options: [
                      {
                        _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        description: 'Classic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Classic Green+',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.709Z',
                        _updated_at: '2025-05-23T06:23:55.130Z',
                        _title: 'Classic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                        }
                      },
                      {
                        _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        billing_duration_unit: 'months',
                        description: 'Dynamic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: true,
                        notice_time_unit: 'months',
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: 'per_unit',
                        renewal_duration_unit: 'months',
                        termination_time_unit: 'months',
                        tiers: [],
                        type: 'one_time',
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: false,
                        billing_period: 'weekly',
                        internal_description: 'Dynamic Green+',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.918Z',
                        _updated_at: '2025-05-23T06:24:15.056Z',
                        _title: 'Dynamic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [],
                    type: 'product',
                    _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                    _title: 'Strom Green+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 0
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_net: 20,
                  unit_amount_gross: 24,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_tax: 0,
                  dynamic_tariff: {
                    interval: 'hourly',
                    markup: 0,
                    markup_amount: 15,
                    markup_amount_decimal: '0.1511',
                    markup_decimal: '0.00',
                    mode: 'day_ahead_market',
                    markup_amount_net: 13,
                    markup_amount_gross: 15,
                    unit_amount_net: 8,
                    unit_amount_gross: 9,
                    unit_amount_net_decimal: '0.0779',
                    unit_amount_gross_decimal: '0.092701',
                    markup_amount_net_decimal: '0.126974789916',
                    markup_amount_gross_decimal: '0.1511'
                  },
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '0.204874789916',
                  unit_amount_gross_decimal: '0.243801',
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0'
                },
                {
                  price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
                  product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                  quantity: 1,
                  description: 'Umlagen, Abgaben, Steuern, etc.',
                  unit_amount: 16,
                  unit_amount_decimal: '0.1611',
                  pricing_model: 'per_unit',
                  _price: {
                    _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Umlagen, Abgaben, Steuern, etc.',
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 16,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.1611',
                    variable_price: true,
                    billing_period: 'monthly',
                    internal_description: 'Umlagen, Abgaben, Steuern, etc.',
                    _title: 'Umlagen, Abgaben, Steuern, etc.',
                    averageMarketPrice: {
                      market: 'day_ahead',
                      bidding_zone: 'DE-LU',
                      price: {
                        timestamp:
                          '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                        unit_amount: 7.79,
                        unit_amount_decimal: '0.0779',
                        unit_amount_currency: 'EUR'
                      },
                      _meta: {
                        timestamp: 1747981644144,
                        signature:
                          'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                      },
                      inputs: {
                        market: 'day_ahead',
                        bidding_zone: 'DE-LU',
                        from: '2025-04-01',
                        to: '2025-04-30'
                      }
                    }
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom', 'dont-touch'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature: '100% Ökostrom',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Strom Green+',
                    name: 'Strom Green+',
                    price_options: [
                      {
                        _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        description: 'Classic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Classic Green+',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.709Z',
                        _updated_at: '2025-05-23T06:23:55.130Z',
                        _title: 'Classic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                        }
                      },
                      {
                        _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        billing_duration_unit: 'months',
                        description: 'Dynamic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: true,
                        notice_time_unit: 'months',
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: 'per_unit',
                        renewal_duration_unit: 'months',
                        termination_time_unit: 'months',
                        tiers: [],
                        type: 'one_time',
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: false,
                        billing_period: 'weekly',
                        internal_description: 'Dynamic Green+',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.918Z',
                        _updated_at: '2025-05-23T06:24:15.056Z',
                        _title: 'Dynamic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [],
                    type: 'product',
                    _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                    _title: 'Strom Green+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 0
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_net: 14,
                  unit_amount_gross: 16,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_tax: 0,
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '0.135378151261',
                  unit_amount_gross_decimal: '0.1611',
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0'
                }
              ],
              _price: {
                _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Dynamic Green+',
                is_composite_price: true,
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_components: [
                  {
                    _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                    _manifest: [
                      '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                      '50fb9921-3b0d-430a-9211-5b741e601008',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Grundpreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'tiered_volume',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    tiers: [],
                    type: 'recurring',
                    unit_amount: 1300,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '13',
                    variable_price: true,
                    billing_duration_amount: '',
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Grundpreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Grundpreis'
                  },
                  {
                    _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Energie Spotmarktpreis',
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'dynamic_tariff',
                    renewal_duration_unit: 'months',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: true,
                    billing_period: 'monthly',
                    dynamic_tariff: {
                      interval: 'hourly',
                      markup: 0,
                      markup_amount: 15,
                      markup_amount_decimal: '0.1511',
                      markup_decimal: '0.00',
                      mode: 'day_ahead_market'
                    },
                    internal_description: 'Energie Spotmarktpreis',
                    _title: 'Energie Spotmarktpreis'
                  },
                  {
                    _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Umlagen, Abgaben, Steuern, etc.',
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 16,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.1611',
                    variable_price: true,
                    billing_period: 'monthly',
                    internal_description: 'Umlagen, Abgaben, Steuern, etc.',
                    _title: 'Umlagen, Abgaben, Steuern, etc.'
                  }
                ],
                price_display_in_journeys: 'show_price',
                pricing_model: 'per_unit',
                renewal_duration_unit: 'months',
                termination_time_unit: 'months',
                tiers: [],
                type: 'one_time',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: false,
                billing_period: 'weekly',
                internal_description: 'Dynamic Green+',
                _title: 'Dynamic Green+'
              },
              _product: {
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom', 'dont-touch'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature: '100% Ökostrom',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Strom Green+',
                name: 'Strom Green+',
                price_options: [
                  {
                    _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Classic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Classic Green+',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.709Z',
                    _updated_at: '2025-05-23T06:23:55.130Z',
                    _title: 'Classic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                    }
                  },
                  {
                    _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Dynamic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'one_time',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: false,
                    billing_period: 'weekly',
                    internal_description: 'Dynamic Green+',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.918Z',
                    _updated_at: '2025-05-23T06:24:15.056Z',
                    _title: 'Dynamic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.522Z',
                    _updated_at: '2025-04-04T07:57:21.022Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                    $relation: {
                      entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                    }
                  },
                  {
                    _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.247Z',
                    _updated_at: '2025-04-04T07:57:21.704Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                    $relation: {
                      entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                    }
                  },
                  {
                    _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.101Z',
                    _updated_at: '2025-04-04T07:57:21.569Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                    $relation: {
                      entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                    }
                  },
                  {
                    _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.386Z',
                    _updated_at: '2025-04-04T07:57:20.823Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                    $relation: {
                      entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                    }
                  }
                ],
                product_images: [],
                type: 'product',
                _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _title: 'Strom Green+',
                _messages: {}
              },
              external_price_metadata: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              },
              external_fees_mappings: [
                {
                  price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                  amount_total: 7.79,
                  amount_total_decimal: '0.0779'
                }
              ],
              price_mappings: [
                {
                  price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                  value: 0
                },
                {
                  price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                  value: 0
                },
                {
                  price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
                  value: 0
                }
              ],
              currency: 'EUR',
              amount_subtotal: 0,
              amount_total: 0,
              total_details: {
                amount_tax: 0,
                breakdown: {
                  taxes: [
                    {
                      tax: {
                        _id: '170d696a-611a-4627-a904-137741027989',
                        type: 'VAT',
                        rate: '19'
                      },
                      amount: 0
                    }
                  ],
                  recurrences: [
                    {
                      type: 'recurring',
                      billing_period: 'monthly',
                      unit_amount_gross: 40,
                      amount_subtotal: 0,
                      amount_total: 0,
                      amount_subtotal_decimal: '0',
                      amount_total_decimal: '0',
                      amount_tax: 0
                    }
                  ],
                  recurrencesByTax: [
                    {
                      type: 'recurring',
                      billing_period: 'monthly',
                      amount_total: 0,
                      amount_subtotal: 0,
                      amount_tax: 0,
                      tax: {
                        tax: {
                          _id: '170d696a-611a-4627-a904-137741027989',
                          type: 'VAT',
                          rate: '19'
                        },
                        amount: 0
                      }
                    }
                  ],
                  cashbacks: []
                }
              },
              amount_tax: 0,
              amount_subtotal_decimal: '0',
              amount_total_decimal: '0'
            }
          ],
          amount_subtotal: 0,
          amount_total: 0,
          total_details: {
            amount_tax: 0,
            breakdown: {
              taxes: [
                {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 0
                }
              ],
              recurrences: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_gross: 40,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0',
                  amount_tax: 0
                }
              ],
              recurrencesByTax: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  amount_total: 0,
                  amount_subtotal: 0,
                  amount_tax: 0,
                  tax: {
                    tax: {
                      _id: '170d696a-611a-4627-a904-137741027989',
                      type: 'VAT',
                      rate: '19'
                    },
                    amount: 0
                  }
                }
              ],
              cashbacks: []
            }
          },
          currency: 'EUR',
          redeemed_promos: [],
          start_date: '2025-01-01',
          end_date: null,
          _tags: ['dont-touch'],
          amount_tax: 0,
          prices: {
            $relation: [
              {
                entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                _schema: 'price',
                _tags: []
              }
            ]
          },
          products: {
            $relation: [
              {
                entity_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _schema: 'product',
                _tags: []
              }
            ]
          },
          notice_time_amount: '2',
          billing_address: {
            $relation_ref: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                path: 'address',
                _id: 'L6sB14Iori1DB0PodxizK'
              }
            ]
          },
          delivery_address: [
            {
              _id: '9RpwXqqpoKV9QkrJiJ7sV',
              _tags: [],
              street: 'Adolf-Fischer-Str.',
              zip: '',
              city: 'Köln',
              country: 'DE',
              additional_info: 'Penthouse',
              postal_code: '50670',
              street_number: '2'
            }
          ],
          payment: {
            $relation_ref: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                path: 'payment',
                _id: 'UvxxbZ13mCnwchDZxheL8'
              }
            ]
          },
          $relation: {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        }
      ],
      _updated_at: '2025-05-23T06:18:09.077Z',
      obis_number: '2-3:6.8.9',
      direction: 'feed-in',
      tariff_type: 'et',
      unit: 'kWh',
      transformer_ratio: '1',
      counters: [
        {
          _id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5',
          obis_number: '1:2-6.0',
          direction: 'feed-in',
          tariff_type: 'et',
          unit: 'kWh',
          _tags: ['dont-touch'],
          _schema: 'meter_counter',
          _org: '16246022',
          _created_at: '2025-05-07T11:45:33.418Z',
          _updated_at: '2025-05-23T06:19:04.645Z',
          _title: '1:2-6.0',
          transformer_ratio: '10',
          conversion_factor: '0.01',
          $relation: {
            entity_id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5',
            _schema: 'meter_counter',
            _tags: []
          }
        }
      ],
      _files: [
        {
          _id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b',
          filename: 'Ablesung 2025-05-07T13:48:08+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/76f4982f-a06c-4217-9ee5-4e88228fed79/Ablesung%25202025-05-07T13%253A48%253A08%252B02%253A00.jpg',
          size_bytes: 5661,
          readable_size: '5.53 KB',
          mime_type: 'image/png',
          width: 261,
          height: 355,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/76f4982f-a06c-4217-9ee5-4e88228fed79/Ablesung%202025-05-07T13%3A48%3A08%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-05-07T13:48:08+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/76f4982f-a06c-4217-9ee5-4e88228fed79/Ablesung%25202025-05-07T13%253A48%253A08%252B02%253A00.jpg',
              size_bytes: 5661,
              readable_size: '5.53 KB',
              mime_type: 'image/png',
              width: 261,
              height: 355,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/76f4982f-a06c-4217-9ee5-4e88228fed79/Ablesung%202025-05-07T13%3A48%3A08%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-05-07T11:48:09.880Z',
          _updated_at: '2025-05-07T11:48:09.880Z',
          _title: 'Ablesung 2025-05-07T13:48:08+02:00.jpg',
          $relation: {
            entity_id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b'
          }
        },
        {
          _id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46',
          filename: 'Ablesung 2025-05-07T13:50:09+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/11862049-ce19-4376-b290-436bf3f5d58d/Ablesung%25202025-05-07T13%253A50%253A09%252B02%253A00.jpg',
          size_bytes: 5661,
          readable_size: '5.53 KB',
          mime_type: 'image/png',
          width: 261,
          height: 355,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/11862049-ce19-4376-b290-436bf3f5d58d/Ablesung%202025-05-07T13%3A50%3A09%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-05-07T13:50:09+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/11862049-ce19-4376-b290-436bf3f5d58d/Ablesung%25202025-05-07T13%253A50%253A09%252B02%253A00.jpg',
              size_bytes: 5661,
              readable_size: '5.53 KB',
              mime_type: 'image/png',
              width: 261,
              height: 355,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/11862049-ce19-4376-b290-436bf3f5d58d/Ablesung%202025-05-07T13%3A50%3A09%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-05-07T11:50:10.655Z',
          _updated_at: '2025-05-07T11:50:10.655Z',
          _title: 'Ablesung 2025-05-07T13:50:09+02:00.jpg',
          $relation: {
            entity_id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46'
          }
        },
        {
          _id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c',
          filename: 'Ablesung 2025-05-07T13:50:38+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/3bfe4a59-5280-4dcc-a488-6ac26302572d/Ablesung%25202025-05-07T13%253A50%253A38%252B02%253A00.jpg',
          size_bytes: 5661,
          readable_size: '5.53 KB',
          mime_type: 'image/png',
          width: 261,
          height: 355,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/3bfe4a59-5280-4dcc-a488-6ac26302572d/Ablesung%202025-05-07T13%3A50%3A38%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-05-07T13:50:38+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/3bfe4a59-5280-4dcc-a488-6ac26302572d/Ablesung%25202025-05-07T13%253A50%253A38%252B02%253A00.jpg',
              size_bytes: 5661,
              readable_size: '5.53 KB',
              mime_type: 'image/png',
              width: 261,
              height: 355,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/3bfe4a59-5280-4dcc-a488-6ac26302572d/Ablesung%202025-05-07T13%3A50%3A38%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-05-07T11:50:40.529Z',
          _updated_at: '2025-05-07T11:50:40.529Z',
          _title: 'Ablesung 2025-05-07T13:50:38+02:00.jpg',
          $relation: {
            entity_id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c'
          }
        },
        {
          _id: '70550f17-7337-4514-9044-0962f000e949',
          filename: 'Ablesung 2025-05-07T14:33:56+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/12cdebdb-4b59-42fe-8eb4-3e5003d470bd/Ablesung%25202025-05-07T14%253A33%253A56%252B02%253A00.jpg',
          size_bytes: 5661,
          readable_size: '5.53 KB',
          mime_type: 'image/png',
          width: 261,
          height: 355,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/12cdebdb-4b59-42fe-8eb4-3e5003d470bd/Ablesung%202025-05-07T14%3A33%3A56%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-05-07T14:33:56+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/12cdebdb-4b59-42fe-8eb4-3e5003d470bd/Ablesung%25202025-05-07T14%253A33%253A56%252B02%253A00.jpg',
              size_bytes: 5661,
              readable_size: '5.53 KB',
              mime_type: 'image/png',
              width: 261,
              height: 355,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/12cdebdb-4b59-42fe-8eb4-3e5003d470bd/Ablesung%202025-05-07T14%3A33%3A56%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-05-07T12:33:58.155Z',
          _updated_at: '2025-05-07T12:33:58.155Z',
          _title: 'Ablesung 2025-05-07T14:33:56+02:00.jpg',
          $relation: {
            entity_id: '70550f17-7337-4514-9044-0962f000e949'
          }
        },
        {
          _id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b',
          filename: 'Ablesung 2025-05-07T16:25:43+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/b0c27658-4046-47c8-be77-4e557200f555/Ablesung%25202025-05-07T16%253A25%253A43%252B02%253A00.jpg',
          size_bytes: 32361,
          readable_size: '31.6 KB',
          mime_type: 'image/png',
          width: 298,
          height: 240,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/b0c27658-4046-47c8-be77-4e557200f555/Ablesung%202025-05-07T16%3A25%3A43%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Ablesung 2025-05-07T16:25:43+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/b0c27658-4046-47c8-be77-4e557200f555/Ablesung%25202025-05-07T16%253A25%253A43%252B02%253A00.jpg',
              size_bytes: 32361,
              readable_size: '31.6 KB',
              mime_type: 'image/png',
              width: 298,
              height: 240,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/b0c27658-4046-47c8-be77-4e557200f555/Ablesung%202025-05-07T16%3A25%3A43%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-05-07T14:25:45.775Z',
          _updated_at: '2025-05-07T14:25:45.775Z',
          _title: 'Ablesung 2025-05-07T16:25:43+02:00.jpg',
          $relation: {
            entity_id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b'
          }
        }
      ],
      ma_lo_id: 'DE228554800',
      used_for: 'Haushaltsstrom',
      manufacturer: 'EMH',
      calibration_date: '2025-01-01',
      location: 'Werkstatt',
      customer: [
        {
          _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          _org: '16246022',
          _schema: 'contact',
          last_name: 'Spark',
          first_name: 'Max',
          email: [
            {
              email: 'maxspark360@gmail.com',
              _id: 'HfAOh-AdruvBugA1FbjQf',
              id: 'q37xcz3'
            }
          ],
          payment: [
            {
              _tags: [],
              _id: 'UvxxbZ13mCnwchDZxheL8',
              data: {
                consent: true,
                fullname: 'Max Spark',
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030',
                start_date: '2025-01-01'
              },
              type: 'payment_sepa',
              id: 'eb4tss8'
            },
            {
              _tags: [],
              _id: 'xLMGLijTFmrQilKXlyKU8',
              data: {
                consent: true,
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030',
                fullname: 'Max Spark'
              },
              type: 'payment_sepa',
              id: 'frsd5ru'
            },
            {
              _tags: [],
              _id: 'Eo67TPiGhp7NhOtj6Nc5E',
              data: {
                consent: true,
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030',
                fullname: 'Max Spark'
              },
              type: 'payment_sepa',
              id: 'h1811tg'
            },
            {
              _tags: [],
              _id: '0vEXDJ9JySVANsfaY5wAe',
              data: {
                consent: true,
                fullname: 'Max Spark',
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030'
              },
              type: 'payment_sepa',
              id: '1xu838y'
            }
          ],
          birthdate: '1982-09-01',
          address: [
            {
              country: 'DE',
              city: 'Köln',
              _tags: ['delivery', 'billing'],
              additional_info: 'Penthouse',
              street: 'Adolf-Fischer-Str.',
              street_number: '2',
              _id: 'L6sB14Iori1DB0PodxizK',
              postal_code: '50670',
              id: '4ci2bne'
            }
          ],
          phone: [
            {
              phone: '012341234123',
              _id: 'UAa6m3SewPKOWJJXTXC3G',
              id: 'ewodw6a'
            }
          ],
          _created_at: '2025-04-04T09:18:17.430Z',
          _title: 'Max Spark',
          consent_email_marketing: {
            status: 'active',
            identifiers: [
              {
                identifier: 'maxspark360@gmail.com',
                status: 'active'
              }
            ]
          },
          consent_sms_marketing: {
            status: 'active',
            identifiers: [
              {
                identifier: '012341234123',
                status: 'active'
              }
            ]
          },
          consent_phone_call: {
            status: 'active',
            identifiers: [
              {
                identifier: '012341234123',
                status: 'active'
              }
            ]
          },
          consent_print_marketing: {
            status: 'unknown',
            identifiers: [
              {
                identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                status: 'unknown'
              }
            ]
          },
          _files: {
            $relation: [
              {
                entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
              },
              {
                entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
              },
              {
                entity_id: '5b03a66f-0385-4533-b780-62052cbfeeaa'
              },
              {
                entity_id: '2e8c7821-2551-41aa-b821-894c197ba420'
              },
              {
                entity_id: 'ef7d78d6-7d65-4892-9266-0f9584ab277b'
              },
              {
                entity_id: 'c0ef117f-9416-4240-8a94-694c6b67511f'
              },
              {
                entity_id: '1e1f456a-926f-43fb-a581-873aa693bbdd'
              },
              {
                entity_id: 'e095ebfc-6845-4851-94c4-cf32c71383b4'
              }
            ]
          },
          first_ecp_login: '2025-04-04T13:56:15.807Z',
          _pending_changes: {},
          journey_actions: [],
          files: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: [
                'Commodity',
                'Bestellbestätigung',
                'B2C',
                'message_attachment'
              ],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156167,
              readable_size: '152.51 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              },
              versions: [
                {
                  filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
                  access_control: 'public-read',
                  document_type: 'document',
                  _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
                  _purpose: [
                    'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                    'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                    '6cf77479-becb-408b-a72e-b342bdc87f09',
                    '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
                  ],
                  shared_with_end_customer: true,
                  type: 'document',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
                  size_bytes: 156167,
                  readable_size: '152.51 KB',
                  mime_type: 'application/pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
                  }
                }
              ],
              _schema: 'file',
              _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
              _org: '16246022',
              _created_at: '2025-04-07T07:16:36.872Z',
              _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              _updated_at: '2025-04-07T07:16:38.668Z'
            },
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: [
                'Commodity',
                'Bestellbestätigung',
                'B2C',
                'message_attachment'
              ],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 153036,
              readable_size: '149.45 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              },
              versions: [
                {
                  filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
                  access_control: 'public-read',
                  document_type: 'document',
                  _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
                  _purpose: [
                    'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                    'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                    '6cf77479-becb-408b-a72e-b342bdc87f09',
                    '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
                  ],
                  shared_with_end_customer: true,
                  type: 'document',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
                  size_bytes: 153036,
                  readable_size: '149.45 KB',
                  mime_type: 'application/pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
                  }
                }
              ],
              _schema: 'file',
              _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
              _org: '16246022',
              _created_at: '2025-04-07T07:00:37.276Z',
              _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              _updated_at: '2025-04-07T07:00:38.801Z'
            },
            {
              filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: [
                'Commodity',
                'Bestellbestätigung',
                'B2C',
                'message_attachment'
              ],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156303,
              readable_size: '152.64 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              },
              versions: [
                {
                  filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
                  access_control: 'public-read',
                  document_type: 'document',
                  _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
                  _purpose: [
                    'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                    'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                    '6cf77479-becb-408b-a72e-b342bdc87f09',
                    '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
                  ],
                  shared_with_end_customer: true,
                  type: 'document',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
                  size_bytes: 156303,
                  readable_size: '152.64 KB',
                  mime_type: 'application/pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
                  }
                }
              ],
              _schema: 'file',
              _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
              _org: '16246022',
              _created_at: '2025-04-04T13:52:22.441Z',
              _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              _updated_at: '2025-04-04T13:52:24.321Z'
            }
          ],
          language: 'en',
          customer_number: '1234567880',
          salutation: 'Mr.',
          inbetriebnahme: false,
          _updated_at: '2025-06-12T06:03:13.192Z',
          $relation: {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        }
      ],
      _relations: [
        {
          entity_id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46'
        },
        {
          entity_id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b'
        },
        {
          entity_id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c'
        },
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
        },
        {
          entity_id: '70550f17-7337-4514-9044-0962f000e949'
        },
        {
          entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
        },
        {
          entity_id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b'
        },
        {
          entity_id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5'
        }
      ],
      _messages: {
        total_messages: 0,
        unread_count: 0
      },
      journey_actions: []
    },
    {
      ma_lo_id: 'DE556303201',
      meter_type: 'electronic-meter',
      sector: 'power',
      status: 'active',
      address: [
        {
          _id: 'pdV3uRTxUqUS0N9-IWluf',
          _tags: [],
          street: '',
          zip: '',
          city: '',
          country: ''
        }
      ],
      _tags: ['dont-touch'],
      _schema: 'meter',
      _id: '6f4f9267-3372-4602-a542-babbe0515c03',
      _org: '16246022',
      _created_at: '2025-04-22T09:06:07.905Z',
      _title: '1ESY2450095087093',
      obis_number: '6583430',
      direction: 'feed-out',
      tariff_type: 'et',
      unit: 'kWh',
      counters: [
        {
          _id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
          obis_number: '1-0:1.8.0',
          direction: 'feed-out',
          unit: 'kWh',
          _tags: ['dont-touch'],
          _schema: 'meter_counter',
          _org: '16246022',
          _created_at: '2025-04-22T09:08:09.146Z',
          _updated_at: '2025-05-23T06:10:07.956Z',
          _title: '1-0:1.8.0',
          tariff_type: 'et',
          transformer_ratio: '10',
          conversion_factor: '0.01',
          $relation: {
            entity_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
            _tags: []
          }
        }
      ],
      contract: [
        {
          _id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58',
          line_items: [
            {
              price_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
              product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              quantity: 1,
              description: 'Classic Green+',
              unit_amount: 0,
              unit_amount_decimal: '0.00',
              pricing_model: null,
              item_components: [
                {
                  price_id: 'a5843c03-1377-40c4-bd0c-b294047dad88',
                  product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                  quantity: 1,
                  description: 'Grundpreis',
                  unit_amount: 1300,
                  unit_amount_decimal: '13',
                  pricing_model: 'per_unit',
                  _price: {
                    _id: 'a5843c03-1377-40c4-bd0c-b294047dad88',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Grundpreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    tiers: [],
                    type: 'recurring',
                    unit_amount: 1300,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '13',
                    variable_price: null,
                    billing_duration_amount: '',
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Grundpreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Grundpreis'
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom', 'dont-touch'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature: '100% Ökostrom',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Strom Green+',
                    name: 'Strom Green+',
                    price_options: [
                      {
                        _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        description: 'Classic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Classic Green+',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.709Z',
                        _updated_at: '2025-05-23T06:23:55.130Z',
                        _title: 'Classic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [],
                    type: 'product',
                    _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                    _title: 'Strom Green+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 208
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_net: 1092,
                  unit_amount_gross: 1300,
                  amount_subtotal: 1092,
                  amount_total: 1300,
                  amount_tax: 208,
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '10.924369747899',
                  unit_amount_gross_decimal: '13',
                  amount_subtotal_decimal: '10.924369747899',
                  amount_total_decimal: '13'
                },
                {
                  price_id: 'fa731291-61fe-439d-867b-6cf885d36e0b',
                  product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                  quantity: 1,
                  description: 'Arbeitspreis',
                  unit_amount: 13,
                  unit_amount_decimal: '0.1302',
                  pricing_model: 'per_unit',
                  _price: {
                    _id: 'fa731291-61fe-439d-867b-6cf885d36e0b',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Arbeitspreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: [
                      {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      }
                    ],
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 13,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.1302',
                    variable_price: true,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Arbeitspreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Arbeitspreis'
                  },
                  _product: {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom', 'dont-touch'],
                    active: true,
                    categories: [],
                    description: 'Außerhalb der Grundversorgung',
                    feature: [
                      {
                        _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                        _tags: [],
                        feature: '100% Ökostrom',
                        value: ''
                      },
                      {
                        _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                        _tags: [],
                        feature: 'Erstlaufzeit bis 31.12.2025',
                        value: ''
                      },
                      {
                        _id: 'SbRtgtY6flxvlR1M-LaHi',
                        _tags: [],
                        feature: 'Kündigungsfrist 1 Monat',
                        value: ''
                      },
                      {
                        _id: 'v07rw_RfinlcUOfQD0h9S',
                        _tags: [],
                        feature:
                          '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                        value: ''
                      }
                    ],
                    internal_name: 'Strom Green+',
                    name: 'Strom Green+',
                    price_options: [
                      {
                        _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                        _schema: 'price',
                        _tags: ['Commodity', 'Strom'],
                        active: true,
                        description: 'Classic Green+',
                        is_composite_price: true,
                        is_tax_inclusive: null,
                        price_components: [],
                        price_display_in_journeys: 'show_price',
                        pricing_model: null,
                        tiers: [],
                        type: null,
                        unit_amount: 0,
                        unit_amount_currency: 'EUR',
                        unit_amount_decimal: '0.00',
                        variable_price: null,
                        billing_duration_amount: null,
                        billing_duration_unit: null,
                        billing_period: null,
                        internal_description: 'Classic Green+',
                        notice_time_amount: null,
                        notice_time_unit: null,
                        renewal_duration_amount: null,
                        renewal_duration_unit: null,
                        termination_time_amount: null,
                        termination_time_unit: null,
                        unit: null,
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:27.709Z',
                        _updated_at: '2025-05-23T06:23:55.130Z',
                        _title: 'Classic Green+',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        $relation: {
                          entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                        }
                      }
                    ],
                    product_downloads: [
                      {
                        _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Datenschutz'],
                            _title: 'Datenschutzinformationen.pdf',
                            access_control: 'public-read',
                            filename: 'Datenschutzinformationen.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.522Z',
                        _updated_at: '2025-04-04T07:57:21.022Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                        $relation: {
                          entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                        }
                      },
                      {
                        _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'AGB'],
                            _title: 'AGB.pdf',
                            access_control: 'public-read',
                            filename: 'AGB.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.247Z',
                        _updated_at: '2025-04-04T07:57:21.704Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                        $relation: {
                          entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                        }
                      },
                      {
                        _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Widerrufsformular'],
                            _title: 'Muster-Widerrufsformular.pdf',
                            access_control: 'public-read',
                            filename: 'Muster-Widerrufsformular.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:21.101Z',
                        _updated_at: '2025-04-04T07:57:21.569Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                        $relation: {
                          entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                        }
                      },
                      {
                        _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        },
                        versions: [
                          {
                            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                            _purpose: [],
                            _tags: ['Commodity', 'Preisblatt'],
                            _title: 'Preisblatt.pdf',
                            access_control: 'public-read',
                            filename: 'Preisblatt.pdf',
                            mime_type: 'application/pdf',
                            type: 'document',
                            category: 'unknown',
                            file_entity_id: '',
                            size_bytes: 11451,
                            readable_size: '11.18 KB',
                            public_url:
                              'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                            s3ref: {
                              bucket: 'epilot-prod-user-content',
                              key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                            }
                          }
                        ],
                        _schema: 'file',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:57:20.386Z',
                        _updated_at: '2025-04-04T07:57:20.823Z',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        },
                        source_url:
                          'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                        $relation: {
                          entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                        }
                      }
                    ],
                    product_images: [],
                    type: 'product',
                    _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                    _title: 'Strom Green+',
                    _messages: {}
                  },
                  taxes: [
                    {
                      tax: {
                        _manifest: [
                          '956e9f44-0d8e-4d50-af85-e528fb130d64',
                          'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                          '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                          '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                          '4573c148-9fa1-4de8-bb05-964a01690789'
                        ],
                        _schema: 'tax',
                        active: true,
                        description: '19%',
                        rate: '19',
                        region: 'DE',
                        type: 'VAT',
                        _id: '170d696a-611a-4627-a904-137741027989',
                        _org: '16246022',
                        _owners: [
                          {
                            org_id: '16246022',
                            user_id: '140034'
                          }
                        ],
                        _created_at: '2025-04-04T07:09:29.464Z',
                        _updated_at: '2025-04-04T07:57:19.848Z',
                        _title: '19%',
                        _acl: {
                          view: ['org_16246022'],
                          edit: ['org_16246022'],
                          delete: ['org_16246022']
                        }
                      },
                      amount: 0
                    }
                  ],
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_net: 11,
                  unit_amount_gross: 13,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_tax: 0,
                  currency: 'EUR',
                  is_tax_inclusive: true,
                  unit_amount_net_decimal: '0.109411764706',
                  unit_amount_gross_decimal: '0.1302',
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0'
                }
              ],
              _price: {
                _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                description: 'Classic Green+',
                is_composite_price: true,
                is_tax_inclusive: null,
                price_components: [
                  {
                    _id: 'a5843c03-1377-40c4-bd0c-b294047dad88',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Grundpreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    tiers: [],
                    type: 'recurring',
                    unit_amount: 1300,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '13',
                    variable_price: null,
                    billing_duration_amount: '',
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Grundpreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Grundpreis'
                  },
                  {
                    _id: 'fa731291-61fe-439d-867b-6cf885d36e0b',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Arbeitspreis',
                    is_tax_inclusive: true,
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    tax: {
                      $relation: [
                        {
                          entity_id: '170d696a-611a-4627-a904-137741027989'
                        }
                      ]
                    },
                    tiers: [],
                    type: 'recurring',
                    unit: 'kwh',
                    unit_amount: 13,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.1302',
                    variable_price: true,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: 'monthly',
                    internal_description: 'Arbeitspreis',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    price_components: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    _title: 'Arbeitspreis'
                  }
                ],
                price_display_in_journeys: 'show_price',
                pricing_model: null,
                tiers: [],
                type: null,
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: null,
                billing_duration_amount: null,
                billing_duration_unit: null,
                billing_period: null,
                internal_description: 'Classic Green+',
                notice_time_amount: null,
                notice_time_unit: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                unit: null,
                _title: 'Classic Green+'
              },
              _product: {
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom', 'dont-touch'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature: '100% Ökostrom',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Strom Green+',
                name: 'Strom Green+',
                price_options: [
                  {
                    _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Classic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Classic Green+',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.709Z',
                    _updated_at: '2025-05-23T06:23:55.130Z',
                    _title: 'Classic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.522Z',
                    _updated_at: '2025-04-04T07:57:21.022Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                    $relation: {
                      entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                    }
                  },
                  {
                    _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.247Z',
                    _updated_at: '2025-04-04T07:57:21.704Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                    $relation: {
                      entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                    }
                  },
                  {
                    _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.101Z',
                    _updated_at: '2025-04-04T07:57:21.569Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                    $relation: {
                      entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                    }
                  },
                  {
                    _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: '16246022',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.386Z',
                    _updated_at: '2025-04-04T07:57:20.823Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                    $relation: {
                      entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                    }
                  }
                ],
                product_images: [],
                type: 'product',
                _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _title: 'Strom Green+',
                _messages: {}
              },
              price_mappings: [
                {
                  price_id: 'fa731291-61fe-439d-867b-6cf885d36e0b',
                  value: 0
                }
              ],
              currency: 'EUR',
              amount_subtotal: 1092,
              amount_total: 1300,
              total_details: {
                amount_tax: 208,
                breakdown: {
                  taxes: [
                    {
                      tax: {
                        _id: '170d696a-611a-4627-a904-137741027989',
                        type: 'VAT',
                        rate: '19'
                      },
                      amount: 208
                    }
                  ],
                  recurrences: [
                    {
                      type: 'recurring',
                      billing_period: 'monthly',
                      unit_amount_gross: 1313,
                      unit_amount_net: 1103,
                      amount_subtotal: 1092,
                      amount_total: 1300,
                      amount_subtotal_decimal: '10.924369747899',
                      amount_total_decimal: '13',
                      amount_tax: 208
                    }
                  ],
                  recurrencesByTax: [
                    {
                      type: 'recurring',
                      billing_period: 'monthly',
                      amount_total: 1300,
                      amount_subtotal: 1092,
                      amount_tax: 208,
                      tax: {
                        tax: {
                          _id: '170d696a-611a-4627-a904-137741027989',
                          type: 'VAT',
                          rate: '19'
                        },
                        amount: 208
                      }
                    }
                  ],
                  cashbacks: []
                }
              },
              amount_tax: 208,
              amount_subtotal_decimal: '10.924369747899',
              amount_total_decimal: '13'
            }
          ],
          amount_subtotal: 1092,
          amount_total: 1300,
          total_details: {
            amount_tax: 208,
            breakdown: {
              taxes: [
                {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 208
                }
              ],
              recurrences: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_gross: 1313,
                  unit_amount_net: 1103,
                  amount_subtotal: 1092,
                  amount_total: 1300,
                  amount_subtotal_decimal: '10.924369747899',
                  amount_total_decimal: '13',
                  amount_tax: 208
                }
              ],
              recurrencesByTax: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  amount_total: 1300,
                  amount_subtotal: 1092,
                  amount_tax: 208,
                  tax: {
                    tax: {
                      _id: '170d696a-611a-4627-a904-137741027989',
                      type: 'VAT',
                      rate: '19'
                    },
                    amount: 208
                  }
                }
              ],
              cashbacks: []
            }
          },
          currency: 'EUR',
          redeemed_promos: [],
          contract_name: 'Max Spark Classic Green+',
          contract_number: '589010219',
          start_date: '2025-01-01',
          end_date: null,
          type: 'recurring',
          installment_amount: 7000,
          installment_amount_currency: 'EUR',
          installment_amount_decimal: '70',
          products: {
            $relation: [
              {
                entity_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _schema: 'product',
                _tags: []
              }
            ]
          },
          balance: 0,
          balance_currency: 'EUR',
          balance_decimal: '0.00',
          prices: {
            $relation: [
              {
                entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                _schema: 'price',
                _tags: []
              }
            ]
          },
          _schema: 'contract',
          status: 'active',
          amount_tax: 208,
          billing_period: 'monthly',
          billing_duration_amount: null,
          _org: '16246022',
          _created_at: '2025-04-22T09:01:25.405Z',
          _updated_at: '2025-06-04T09:27:42.421Z',
          billing_duration_unit: 'months',
          notice_time_unit: 'months',
          termination_time_unit: 'months',
          renewal_duration_unit: 'months',
          _title: 'Max Spark Classic Green+',
          move_in_date: '2025-01-01',
          order: {
            $relation: [
              {
                entity_id: 'eaa61bfb-fc94-4f11-8cac-a3183a2f31fd',
                _schema: 'order',
                _tags: []
              }
            ]
          },
          meters: {
            $relation: [
              {
                entity_id: '6f4f9267-3372-4602-a542-babbe0515c03',
                _tags: []
              }
            ]
          },
          customer: {
            $relation: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                _schema: 'contact',
                _tags: []
              }
            ]
          },
          delivery_address: [
            {
              _id: '5NpAsJLJNTlhxXsHDWBve',
              _tags: [],
              street: 'Adolf-Fischer-Str.',
              zip: '',
              city: 'Köln',
              country: 'DE',
              postal_code: '50670',
              street_number: '2',
              additional_info: 'Werkstatt'
            },
            {
              _id: '-ZMdvY7wEMeVRYBTrFGlz',
              _tags: [],
              street: '',
              zip: '',
              city: '',
              country: ''
            }
          ],
          billing_address: {
            $relation_ref: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                path: 'address',
                _id: 'L6sB14Iori1DB0PodxizK'
              }
            ]
          },
          payment: {
            $relation_ref: [
              {
                entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                path: 'payment',
                _id: 'UvxxbZ13mCnwchDZxheL8'
              }
            ]
          },
          billing_due_day: '1',
          notice_time_amount: '2',
          _files: {
            $relation: [
              {
                entity_id: '84c561eb-2798-43b5-9378-72ca959b4e2a',
                _tags: [''],
                added_by: {
                  org_id: '16246022',
                  user_id: '161180'
                }
              }
            ]
          },
          branch: 'power',
          _tags: ['dont-touch'],
          $relation: {
            entity_id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58'
          }
        }
      ],
      _updated_at: '2025-06-04T06:22:28.960Z',
      meter_number: '1ESY2450095087093',
      used_for: 'Haushaltsstrom',
      manufacturer: 'Schneider Electric',
      calibration_date: '2025-01-01',
      location: 'Nebenkeller',
      customer: [
        {
          _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          _org: '16246022',
          _schema: 'contact',
          last_name: 'Spark',
          first_name: 'Max',
          email: [
            {
              email: 'maxspark360@gmail.com',
              _id: 'HfAOh-AdruvBugA1FbjQf',
              id: 'q37xcz3'
            }
          ],
          payment: [
            {
              _tags: [],
              _id: 'UvxxbZ13mCnwchDZxheL8',
              data: {
                consent: true,
                fullname: 'Max Spark',
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030',
                start_date: '2025-01-01'
              },
              type: 'payment_sepa',
              id: 'eb4tss8'
            },
            {
              _tags: [],
              _id: 'xLMGLijTFmrQilKXlyKU8',
              data: {
                consent: true,
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030',
                fullname: 'Max Spark'
              },
              type: 'payment_sepa',
              id: 'frsd5ru'
            },
            {
              _tags: [],
              _id: 'Eo67TPiGhp7NhOtj6Nc5E',
              data: {
                consent: true,
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030',
                fullname: 'Max Spark'
              },
              type: 'payment_sepa',
              id: 'h1811tg'
            },
            {
              _tags: [],
              _id: '0vEXDJ9JySVANsfaY5wAe',
              data: {
                consent: true,
                fullname: 'Max Spark',
                bic_number: 'INGDDEFFXXX',
                bank_name: 'ING-DiBa',
                iban: 'DE02500105170137075030'
              },
              type: 'payment_sepa',
              id: '1xu838y'
            }
          ],
          birthdate: '1982-09-01',
          address: [
            {
              country: 'DE',
              city: 'Köln',
              _tags: ['delivery', 'billing'],
              additional_info: 'Penthouse',
              street: 'Adolf-Fischer-Str.',
              street_number: '2',
              _id: 'L6sB14Iori1DB0PodxizK',
              postal_code: '50670',
              id: '4ci2bne'
            }
          ],
          phone: [
            {
              phone: '012341234123',
              _id: 'UAa6m3SewPKOWJJXTXC3G',
              id: 'ewodw6a'
            }
          ],
          _created_at: '2025-04-04T09:18:17.430Z',
          _title: 'Max Spark',
          consent_email_marketing: {
            status: 'active',
            identifiers: [
              {
                identifier: 'maxspark360@gmail.com',
                status: 'active'
              }
            ]
          },
          consent_sms_marketing: {
            status: 'active',
            identifiers: [
              {
                identifier: '012341234123',
                status: 'active'
              }
            ]
          },
          consent_phone_call: {
            status: 'active',
            identifiers: [
              {
                identifier: '012341234123',
                status: 'active'
              }
            ]
          },
          consent_print_marketing: {
            status: 'unknown',
            identifiers: [
              {
                identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
                status: 'unknown'
              }
            ]
          },
          _files: {
            $relation: [
              {
                entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
              },
              {
                entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
              },
              {
                entity_id: '5b03a66f-0385-4533-b780-62052cbfeeaa'
              },
              {
                entity_id: '2e8c7821-2551-41aa-b821-894c197ba420'
              },
              {
                entity_id: 'ef7d78d6-7d65-4892-9266-0f9584ab277b'
              },
              {
                entity_id: 'c0ef117f-9416-4240-8a94-694c6b67511f'
              },
              {
                entity_id: '1e1f456a-926f-43fb-a581-873aa693bbdd'
              },
              {
                entity_id: 'e095ebfc-6845-4851-94c4-cf32c71383b4'
              }
            ]
          },
          first_ecp_login: '2025-04-04T13:56:15.807Z',
          _pending_changes: {},
          journey_actions: [],
          files: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: [
                'Commodity',
                'Bestellbestätigung',
                'B2C',
                'message_attachment'
              ],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156167,
              readable_size: '152.51 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              },
              versions: [
                {
                  filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
                  access_control: 'public-read',
                  document_type: 'document',
                  _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
                  _purpose: [
                    'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                    'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                    '6cf77479-becb-408b-a72e-b342bdc87f09',
                    '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
                  ],
                  shared_with_end_customer: true,
                  type: 'document',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
                  size_bytes: 156167,
                  readable_size: '152.51 KB',
                  mime_type: 'application/pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
                  }
                }
              ],
              _schema: 'file',
              _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
              _org: '16246022',
              _created_at: '2025-04-07T07:16:36.872Z',
              _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              _updated_at: '2025-04-07T07:16:38.668Z'
            },
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: [
                'Commodity',
                'Bestellbestätigung',
                'B2C',
                'message_attachment'
              ],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 153036,
              readable_size: '149.45 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              },
              versions: [
                {
                  filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
                  access_control: 'public-read',
                  document_type: 'document',
                  _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
                  _purpose: [
                    'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                    'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                    '6cf77479-becb-408b-a72e-b342bdc87f09',
                    '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
                  ],
                  shared_with_end_customer: true,
                  type: 'document',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
                  size_bytes: 153036,
                  readable_size: '149.45 KB',
                  mime_type: 'application/pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
                  }
                }
              ],
              _schema: 'file',
              _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
              _org: '16246022',
              _created_at: '2025-04-07T07:00:37.276Z',
              _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              _updated_at: '2025-04-07T07:00:38.801Z'
            },
            {
              filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: [
                'Commodity',
                'Bestellbestätigung',
                'B2C',
                'message_attachment'
              ],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156303,
              readable_size: '152.64 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              },
              versions: [
                {
                  filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
                  access_control: 'public-read',
                  document_type: 'document',
                  _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
                  _purpose: [
                    'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                    'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                    '6cf77479-becb-408b-a72e-b342bdc87f09',
                    '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
                  ],
                  shared_with_end_customer: true,
                  type: 'document',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
                  size_bytes: 156303,
                  readable_size: '152.64 KB',
                  mime_type: 'application/pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
                  }
                }
              ],
              _schema: 'file',
              _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
              _org: '16246022',
              _created_at: '2025-04-04T13:52:22.441Z',
              _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              _updated_at: '2025-04-04T13:52:24.321Z'
            }
          ],
          language: 'en',
          customer_number: '1234567880',
          salutation: 'Mr.',
          inbetriebnahme: false,
          _updated_at: '2025-06-12T06:03:13.192Z',
          $relation: {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        }
      ],
      _files: [
        {
          _id: '00bc5a7e-66d6-47a8-9727-25492b158b75',
          filename: 'Reading 2025-06-03T13:57:26+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/cb5d9959-1eb0-45a8-8cb4-10491b29484c/Reading%25202025-06-03T13%253A57%253A26%252B02%253A00.jpg',
          size_bytes: 285778,
          readable_size: '279.08 KB',
          mime_type: 'image/png',
          width: 3030,
          height: 1442,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/cb5d9959-1eb0-45a8-8cb4-10491b29484c/Reading%202025-06-03T13%3A57%3A26%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Reading 2025-06-03T13:57:26+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/cb5d9959-1eb0-45a8-8cb4-10491b29484c/Reading%25202025-06-03T13%253A57%253A26%252B02%253A00.jpg',
              size_bytes: 285778,
              readable_size: '279.08 KB',
              mime_type: 'image/png',
              width: 3030,
              height: 1442,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/cb5d9959-1eb0-45a8-8cb4-10491b29484c/Reading%202025-06-03T13%3A57%3A26%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-06-03T11:57:27.860Z',
          _updated_at: '2025-06-03T11:57:27.860Z',
          _title: 'Reading 2025-06-03T13:57:26+02:00.jpg',
          $relation: {
            entity_id: '00bc5a7e-66d6-47a8-9727-25492b158b75'
          }
        },
        {
          _id: '5ff4f3da-c6bf-45db-93d0-0b1750caa412',
          filename: 'Reading 2025-06-03T13:57:57+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/da12d347-7ad5-4ac8-8ef3-b86701e3b951/Reading%25202025-06-03T13%253A57%253A57%252B02%253A00.jpg',
          size_bytes: 12281,
          readable_size: '11.99 KB',
          mime_type: 'image/png',
          width: 402,
          height: 220,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/da12d347-7ad5-4ac8-8ef3-b86701e3b951/Reading%202025-06-03T13%3A57%3A57%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Reading 2025-06-03T13:57:57+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/da12d347-7ad5-4ac8-8ef3-b86701e3b951/Reading%25202025-06-03T13%253A57%253A57%252B02%253A00.jpg',
              size_bytes: 12281,
              readable_size: '11.99 KB',
              mime_type: 'image/png',
              width: 402,
              height: 220,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/da12d347-7ad5-4ac8-8ef3-b86701e3b951/Reading%202025-06-03T13%3A57%3A57%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-06-03T11:57:58.633Z',
          _updated_at: '2025-06-03T11:57:58.633Z',
          _title: 'Reading 2025-06-03T13:57:57+02:00.jpg',
          $relation: {
            entity_id: '5ff4f3da-c6bf-45db-93d0-0b1750caa412'
          }
        },
        {
          _id: 'b6206c46-bd14-41d5-bed5-051281886922',
          filename: 'Reading 2025-06-04T08:22:25+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/c22ac373-5375-40fc-8b59-91f1a6e4cab0/Reading%25202025-06-04T08%253A22%253A25%252B02%253A00.jpg',
          size_bytes: 952387,
          readable_size: '930.07 KB',
          mime_type: 'image/jpeg',
          width: 1200,
          height: 1600,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/c22ac373-5375-40fc-8b59-91f1a6e4cab0/Reading%202025-06-04T08%3A22%3A25%2B02%3A00.jpg'
          },
          versions: [
            {
              filename: 'Reading 2025-06-04T08:22:25+02:00.jpg',
              document_type: 'image',
              access_control: 'private',
              shared_with_end_customer: true,
              type: 'image',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/c22ac373-5375-40fc-8b59-91f1a6e4cab0/Reading%25202025-06-04T08%253A22%253A25%252B02%253A00.jpg',
              size_bytes: 952387,
              readable_size: '930.07 KB',
              mime_type: 'image/jpeg',
              width: 1200,
              height: 1600,
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/c22ac373-5375-40fc-8b59-91f1a6e4cab0/Reading%202025-06-04T08%3A22%3A25%2B02%3A00.jpg'
              }
            }
          ],
          _schema: 'file',
          _org: '16246022',
          _created_at: '2025-06-04T06:22:28.685Z',
          _updated_at: '2025-06-04T06:22:28.685Z',
          _title: 'Reading 2025-06-04T08:22:25+02:00.jpg',
          $relation: {
            entity_id: 'b6206c46-bd14-41d5-bed5-051281886922'
          }
        }
      ],
      _relations: [
        {
          entity_id: '00bc5a7e-66d6-47a8-9727-25492b158b75'
        },
        {
          entity_id: '37cf1e00-d21f-4427-a1e0-d831d094b1cd'
        },
        {
          entity_id: '5ff4f3da-c6bf-45db-93d0-0b1750caa412'
        },
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
        },
        {
          entity_id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58'
        },
        {
          entity_id: 'b6206c46-bd14-41d5-bed5-051281886922'
        },
        {
          entity_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c'
        }
      ],
      _messages: {
        total_messages: 0,
        unread_count: 0
      },
      last_reading: '2025-04-29T22:00:00Z',
      current_consumption: 1265,
      journey_actions: []
    }
  ]
}
